module.exports = __webpack_public_path__ + "static/media/discover-yourself-video-2x.e77dcf04.png";